export const isDateInRange = (start, end, current = new Date()) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  return current >= startDate && current <= endDate;
};
